var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BravadoText',{attrs:{"variant":"body"}},[_c('NuxtLink',{attrs:{"to":`?dynamic_modal=${_vm.$constants.dynamicModals.PUBLIC_PORTFOLIO_AWARDS_MODAL}`},nativeOn:{"click":function($event){return _vm.onTipClick('add-awards')}}},[_vm._v("\n    Add awards\n  ")]),_vm._v("\n  to showcase your sales accomplishments\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }